<template>
  <div>
      <view-package/>
    <!--<v-container class="pt-0">-->

      <v-layout xs12 class="grey lighten-3 no-shadow card-r mt-2 pa-2">
      <v-flex xs12 offset-xs0 class=" ">
        <v-btn color="primary"class="w-100 card-r no-shadow btnM" style="position: fixed; bottom: 10px;">
      Select Pack
      </v-btn>
      </v-flex>
      </v-layout>

    <!--</v-container>-->
  </div>
</template>
<script>
  import ViewPackage from './ViewPackage'
  export default {
    data () {
      return {
      }
    },
    components: {
      ViewPackage
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/pages/package/StudentViewPack.vue